import { Component, h } from 'preact';
import Race from './race';

class Results extends Component {
  render () {
    const races = this.props.races;
    const racesFilter = this.props.racesFilter;

    let results = races;

    if (racesFilter && racesFilter !== 'all' && racesFilter !== 'my-races') {
      results = results.filter((race) => {
        return racesFilter === race.office_slug;
      });
    }

    if (racesFilter === 'my-races') {
      const selected = this.base.querySelectorAll('.race__save-input:checked');

      const ids = [];

      for (let i = 0; i < selected.length; ++i) {
        ids.push(+selected[i].value);
      }

      results = results.filter((race) => {
        return (ids.indexOf(race.id) >= 0);
      });
    }

    results = results.map((race) => {
      return <Race scoreboard={this.props.scoreboard} key={race.id} race={race} />;
    });

    let klass = null;

    if (this.props.scoreboard) {
      klass = 'scoreboard';
    }

    return <div className={klass}>{results}</div>;
  }
}

export default Results;



// WEBPACK FOOTER //
// ./components/results.js